import Modal from "@/components/Modal";
import { fallbackAutoRenewContent } from "@/services/cms";

export type AutoRenewSavingsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onEnroll: () => void;
  body?: string;
  ctaText?: string;
};

export default function AutoRenewSavingsModal({
  isOpen,
  onClose,
  onEnroll,
  body = fallbackAutoRenewContent.body,
  ctaText = fallbackAutoRenewContent.ctaText,
}: AutoRenewSavingsModalProps) {
  if (!isOpen) return null;

  return (
    <Modal open={isOpen} onClose={onClose} showCloseButton={false}>
      <div className="flex w-full max-w-md flex-col rounded-lg bg-[#F6FAFD] p-6 shadow-lg">
        <h2 className="mb-2 font-['Poppins'] text-[26px] font-semibold leading-[31px] text-studer-blue">
          {"Unlock savings with Auto-Renew"}
        </h2>
        <p className="mb-6 text-sm text-gray-500">{body}</p>
        <div className="flex w-full flex-row items-start justify-start gap-4">
          <button
            onClick={onClose}
            className="rounded-lg border border-solid border-[#1fa0e5] bg-white px-4 py-2.5 text-center font-['Open_Sans'] text-[14px] font-semibold leading-5 text-[#1fa0e5]"
          >
            Dismiss
          </button>
          <button
            onClick={onEnroll}
            className="rounded-lg border border-solid border-[#1fa0e5] bg-[#1fa0e5] px-4 py-2.5 text-center font-['Open_Sans'] text-[14px] font-semibold leading-5 text-white"
          >
            {ctaText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
